var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "#fff",
    opacity: 0,
    transform: "matrix(0 -1 1 0 0 24)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 9h13l-1.6 1.2a1 1 0 0 0 -.2 1.4 1 1 0 0 0 .8.4 1 1 0 0 0 .6-.2l4-3a1 1 0 0 0 0-1.59l-3.86-3a1 1 0 0 0 -1.23 1.58l1.57 1.21h-13.08a1 1 0 0 0 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 16h-13l1.6-1.2a1 1 0 0 0 -1.2-1.6l-4 3a1 1 0 0 0 0 1.59l3.86 3a1 1 0 0 0 .61.21 1 1 0 0 0 .79-.39 1 1 0 0 0 -.17-1.4l-1.57-1.21h13.08a1 1 0 0 0 0-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.c404325f9c22d66c1e38787167ac705f.svg";
export { ForwardRef as ReactComponent };